import React from 'react';
import PropTypes from 'prop-types';
import RowContainer from '../../common/CustomComponents/RowContainer';
import { usePageTitle } from '../../common/hooks/usePageTitle';
import { Card } from '@material-ui/core';
import { InfoOutlined } from '@mui/icons-material';
import { CardContent, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import Label from '../../common/type/Label';

// MTMP - Settings Page
const Settings = ({config}) => {
  const response = useSelector(state => state?.updateDemographics?.response);
  const mvSuccessFlag = useSelector(state => state?.memberVerification?.showSuccess);
  usePageTitle('Account Settings');
  return (
    config && (
      <div
        className={config.className}
        id={config.id}
      >
          {response && <Card className='successCardForSm securitySuccessCard'>
                <InfoOutlined color='primary' />
                <CardContent className='successCardContent'>
                    <Typography variant='h6'><Label id='updateRequestReceived'/></Typography>
                    <Typography varaint='body1'><Label id='yourRequestHasBeenForwaded'></Label></Typography>
                </CardContent></Card>}

                {mvSuccessFlag && <Card className='successCardForSm securitySuccessCard'>
                <InfoOutlined color='primary' />
                <CardContent className='successCardContent'>
                    <Typography variant='h6'><Label id='dependentAddedText'/>.</Typography>
                    <Typography varaint='body1'><Label id='dependentSuccess'/>.</Typography>
                </CardContent></Card>}
    <Typography variant='h1' className='settingsTitleText'>
      <Label id='settingsTitleText'/>
    </Typography>

        {config.sections.map((item, index) => {
          return <RowContainer key={index} {...item} />;
        })}
      </div>
    )
  );
};

Settings.propTypes = {
  navigate: PropTypes.func,
  config:PropTypes.object
};

export default Settings;
